import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface TaxRate {
  id?: number;
  county: string;
  rate: number;          // decimal, e.g. 0.04 = 4%
  effectiveFrom: string; // yyyy-MM-dd
  effectiveTo?: string | null;
}

/** Admin client for county TDT tax rates (the tax_rate table the engine reads). */
@Injectable({ providedIn: 'root' })
export class TaxRatesService {
  private baseUrl = `${environment.apiUrl}/api/admin/tax-rates`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<TaxRate[]> {
    return this.http.get<TaxRate[]>(this.baseUrl);
  }
  create(data: TaxRate): Observable<TaxRate> {
    return this.http.post<TaxRate>(this.baseUrl, data);
  }
  update(id: number, data: TaxRate): Observable<TaxRate> {
    return this.http.put<TaxRate>(`${this.baseUrl}/${id}`, data);
  }
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
